import React from 'react'
import {
  Grid,
  Dialog,
  DialogActions as MuiDialogActions,
  DialogContent,
  DialogTitle,
  Button as MuiButton,
  TextField as MuiTextField,
  CircularProgress,
} from '@material-ui/core'
import styled from 'styled-components'
import { spacing } from '@material-ui/system'
import MuiAutocomplete from '@material-ui/lab/Autocomplete'
import { Get } from '../../utils/request'
import { dataToDetails } from '../../utils/contacts'

const Button = styled(MuiButton)(spacing)
const DialogActions = styled(MuiDialogActions)(spacing)
const TextField = styled(MuiTextField)(spacing)

const StyledOption = styled.li`
  cursor: pointer;
  display: flex;
  width: 100%;
  outline: 0;
  box-sizing: border-box;
  align-items: center;
  padding: 6px 16px;
  justify-content: space-between;
`

export default function ContactExistingModal(props) {
  const { open, onClose } = props
  const [contact, setContact] = React.useState(null)
  const [loading, setLoading] = React.useState(false)
  const [options, setOptions] = React.useState([])

  React.useEffect(() => {
    onSearch({ target: { value: '' } })
  }, [])

  const onSearch = async ({ target: { value } }) => {
    setLoading(true)
    const { contacts } = await Get(
      `/api/admin/contacts?filters[search]=${value}`
    )
    setOptions(
      contacts.map((contact) => {
        const { id, data } = contact
        const { firstName, lastName, email } = dataToDetails(data)

        return {
          id,
          label: `${firstName} ${lastName} - ${email}`,
        }
      })
    )
    setLoading(false)
  }

  const onChange = (e, value) => setContact(value)

  const onCancel = () => {
    setContact(null)
    onClose()
  }

  const onAddEntity = () => {
    props.onAttach(contact)
    setContact(null)
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby='form-dialog-title'
      maxWidth='sm'
      fullWidth
    >
      <DialogTitle id='form-dialog-title'>Add Entity</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MuiAutocomplete
              onChange={onChange}
              getOptionLabel={({ n, label }) => `${n ? `${n} - ` : ``}${label}`}
              renderOption={(option) => (
                <StyledOption>
                  <div>{option.label}</div>
                  <div style={{ color: 'slategrey' }}>{`${
                    option.n ? `ID ${option.n}` : ''
                  }`}</div>
                </StyledOption>
              )}
              options={options}
              ChipProps={{ size: 'small' }}
              loading={loading}
              value={contact}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  variant='standard'
                  placeholder={'Select existing contact'}
                  onChange={onSearch}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress color='inherit' size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color='primary'>
          Cancel
        </Button>
        <Button onClick={onAddEntity} color='primary'>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  )
}
